import { CubeSideName } from "../../components/Сube/types";
import { DtoEntry, DtoTestSet, DtoTestSetItem } from "@/types/dto-types";
import { getQuestionsData, getStatisticData } from "./migrated-legacy-utils";
import { Category, ReportSection } from "./types";
import { normalizeValueToPercentage } from "./utils";

export function filterItemsByCategory(
  items: DtoTestSetItem[],
  category: Category
) {
  return items.filter(item => item.category === category);
}

export function getQuestionsDataForCategory(
  testSet: DtoTestSet,
  entries: DtoEntry[],
  filterPredicate: (items: DtoTestSetItem[]) => DtoTestSetItem[]
) {
  const data = getQuestionsData(
    [{ ...testSet, items: filterPredicate(testSet.items) }],
    entries,
    false
  ) as ReportSection;

  data.questions = data.questions.map(question => ({
    ...question,
    average: normalizeValueToPercentage(question.average ?? 0),
  }));

  return data;
}

function mapEntriesToSingleTestSetId(_id: string, entries: DtoEntry[]) {
  return entries.map(entry => ({
    ...entry,
    testSetId: _id,
  }));
}

export function getAggregatedItemsReport(
  currentTestId: string,
  sideName: CubeSideName,
  testSetsByCubeSide: Record<CubeSideName, DtoTestSet[]>,
  entriesGroupedBySide: Record<CubeSideName, DtoEntry[]>
) {
  const testSet = testSetsByCubeSide[sideName].find(
    ts => ts.testId === currentTestId
  );

  if (!testSet) {
    return null;
  }

  const { _id } = testSet;
  // make all entries as one testSet
  const sideEntries = mapEntriesToSingleTestSetId(
    _id,
    entriesGroupedBySide[sideName]
  );

  const testSetWithOtherItems = {
    ...testSet,
    items: testSet.items.filter(item => !item.category),
  };

  return {
    averageScore: getQuestionsDataForCategory(testSet, sideEntries, items =>
      filterItemsByCategory(items, Category.Consent)
    ),
    implementationQuality: getQuestionsDataForCategory(
      testSet,
      sideEntries,
      items => filterItemsByCategory(items, Category.Quality)
    ),
    importance: getQuestionsDataForCategory(testSet, sideEntries, items =>
      filterItemsByCategory(items, Category.Importance)
    ),
    otherScore: getStatisticData([testSetWithOtherItems] as any, sideEntries),
  };
}
